import { Badge } from '@design-system';
import { formatCurrency } from '@shared/formatCurrency';
import { formatCoveragePercentage } from '@/features/shop-insurance';

interface QuotePriceDisplayProps {
  price: number;
  fundingOption?: string;
  label?: string;
  className?: string;
  coveragePercentage?: number;
}

export function QuotePriceDisplay({
  price,
  fundingOption,
  label = 'Cost',
  className = '',
  coveragePercentage,
}: QuotePriceDisplayProps) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <div className="text-muted-foreground text-xs font-medium">{label}</div>
      <div
        data-testid="quote-card-cost-display"
        className="text-primary-dark flex items-center gap-2 text-sm font-semibold sm:text-base"
      >
        {formatCurrency(price)}
        {coveragePercentage !== undefined && (
          <Badge variant="success">{formatCoveragePercentage(coveragePercentage)}% Coverage</Badge>
        )}
      </div>
      {fundingOption && <div className="text-muted-foreground text-xs italic">{fundingOption}</div>}
    </div>
  );
}
